<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="TestTable2" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" :hb_table_class="'hb_table_purchlinereturn_class'"
        @tool_invoke="tool_invoke" @current_changed="current_changed">
        <template #query>
          <el-select v-model="dateChoose" placeholder="" size="small" style="width: 100px">
            <el-option :label="$t('common.delivery_date')" value="date1"></el-option>
            <el-option :label="$t('common.order_date')" value="date2"></el-option>
          </el-select>
          <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
            align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
            :picker-options="pickerOptions()">
          </el-date-picker>
          <el-input style="width: 300px" size="small" placeholder="" v-model="PurchId" class="input-with-select ml-2">
            <el-select v-model="PurchIdType" slot="prepend" :placeholder="$t('common.action_select')"
              style="width: 150px">
              <el-option :label="$t('common.plantform_order_num')" value="1"></el-option>
              <el-option :label="$t('common.ax_order_num')" value="2"></el-option>
            </el-select>
          </el-input>
          <!-- 采购订单编号：<el-input
            size="small"
            style="width: 120px"
            v-model="PurchId"
          ></el-input> -->
          {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
            v-model="ItemId"></el-input>
          {{ $t("common.create_username") }}：<el-input clearable size="small" style="width: 120px"
            v-model="order_user"></el-input>
        </template>
        <template #toolbar="">
          <el-tooltip content="数据同步" placement="top" effect="light">
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i
                class="iconfont icon-refresh"></i></el-button>
          </el-tooltip>
          <!-- <el-button
                type="info"
                plain
                @click="createForm('new')"
                style="width: 55px"
                class="ml-2 iconfont icon-add-new"
                size="mini"
              ></el-button> -->
        </template>
        <!-- <template #operation>
          <el-button type="info" plain size="mini">operation</el-button>
        </template> -->
      </TableMain>
    </BaseContainer>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="dataForm.name"></el-input>
          </el-form-item>
          <el-form-item label="活动区域" prop="region">
            <el-select v-model="dataForm.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间" required>
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker type="date" placeholder="选择日期" v-model="dataForm.date1"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker placeholder="选择时间" v-model="dataForm.date2" style="width: 100%"></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="即时配送" prop="delivery">
            <el-switch v-model="dataForm.delivery"></el-switch>
          </el-form-item>
          <el-form-item label="活动性质" prop="type">
            <el-checkbox-group v-model="dataForm.type">
              <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
              <el-checkbox label="地推活动" name="type"></el-checkbox>
              <el-checkbox label="线下主题活动" name="type"></el-checkbox>
              <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="特殊资源" prop="resource">
            <el-radio-group v-model="dataForm.resource">
              <el-radio label="线上品牌商赞助"></el-radio>
              <el-radio label="线下场地免费"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动形式" prop="desc">
            <el-input type="textarea" v-model="dataForm.desc"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as api from "../../shared/api"
import * as PurchaseLineReturnController from "../../controllers/mm/PurchaseLineReturnController"
import * as CustTableController from "../../controllers/base/CustTableController"

export default {
  name: "SOTracking",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_po_tracking",
      },
      modal_title: "create_purch_trucking",
      fields: PurchaseLineReturnController.fields,
      dataForm: _.cloneDeep(PurchaseLineReturnController.dataForm),
      rules: PurchaseLineReturnController.rules,
      PurchId: "", //采购订单编号
      ItemId: "", //物料编号
      isBusy: false,
      tab_index: 0,
      date_range: "",
      order_user: "",
      dateChoose: "date2",
      PurchIdType: "1",
    }
  },
  created() { },
  mounted() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
  },
  methods: {
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.CustTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 30000)

      let _params = {
        company: "070",
        tableName: "secp_PurchLineReturn",
        accountNum: "", //不传则查询所有
      }
      await CustTableController.methods.pickAndInvoke(_params)

      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
    },
    pickerOptions() {
      let this_ = this
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      let _params = {}
      if (this.dateChoose == "date1") {
        if (!_.isNull(this.date_range) && this.PurchId == "") {
          let _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
          let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
          _toDate = this.$date.format(
            this.$date.addDays(new Date(_toDate), 1),
            "yyyy-MM-dd"
          )
          _params.FromDate = _fromDate
          _params.ToDate = _toDate
        }
      } else {
        if (!_.isNull(this.date_range) && this.PurchId == "") {
          let _fromOrderDate = this.$date.format(
            this.date_range[0],
            "yyyy-MM-dd"
          )
          let _toOrderDate = this.$date.format(
            this.date_range[1],
            "yyyy-MM-dd"
          )
          _toOrderDate = this.$date.format(
            this.$date.addDays(new Date(_toOrderDate), 1),
            "yyyy-MM-dd"
          )
          _params.FromOrderDate = _fromOrderDate
          _params.ToOrderDate = _toOrderDate
        }
      }
      if (this.PurchId != "" && this.PurchIdType == "1") {
        //_params.SalesId = { like: "%" + this.SalesId + "%" };
        _params.PurchId = this.PurchId
      }
      if (this.PurchId != "" && this.PurchIdType == "2") {
        //_params.SalesId = { like: "%" + this.SalesId + "%" };
        _params.AXPurchId = this.PurchId
      }
      if (this.ItemId != "") {
        //_params.ItemId = { like: "%" + this.ItemId + "%" };
        _params.ItemId = this.ItemId
      }
      if (this.order_user != "") {
        _params.order_user = this.order_user
      }
      set_data([])
      let _result = await PurchaseLineReturnController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_purch_trucking"
          break
        case "edit":
          title = "edite_purch_trucking"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
      this.dataForm = _.cloneDeep(PurchaseLineReturnController.dataForm)
    },
    ///新增修改
    saveData(cb) {
      let _this = this
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)

          ///保存数据

          ///成功
          cb(true, true)
          ///失败
          // cb(true, false,"错误：")
        } else {
          cb(false)
          return false
        }
      })
    },
    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
<style>
.hb_table_purchlinereturn_class {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 200rem;
}
</style>
